import axios from "../../axios";

const updateDepositStatus = async function (data, accessToken) {
    try {
        const response = await axios.post('admin/deposit/updateDepositStatus', data, {
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status,
            message: e.response.data.message
        }
    }
}

export default updateDepositStatus; 
